import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Youtube, Facebook, Twitter, Linkedin } from 'lucide-react';
import './css/FooterComponent.css';
import logoImage from '../assets/img/logo-white-red.png';

const FooterComponent = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="main-footer">
      <div className="container-fluid px-lg-5">
        <div className="footer-main-content">
          
          {/* Section 1: Logo and Socials (Mobile: Left) */}
          <div className="footer-left-brand">
            <Link to="/" className="footer-logo-link">
              <img src={logoImage} alt="BookMyAudition" className="footer-logo-img" />
            </Link>
            <p className="footer-tagline">India's trusted talent discovery platform.</p>
            <div className="footer-social-strip">
              <a href="https://instagram.com/bookmyaudition/" target="_blank" rel="noreferrer"><Instagram size={18} /></a>
              <a href="https://www.youtube.com/@bookmyaudition9709" target="_blank" rel="noreferrer"><Youtube size={18} /></a>
              <a href="https://facebook.com/bookmyaudition" target="_blank" rel="noreferrer"><Facebook size={18} /></a>
              <a href="https://twitter.com/Bookmyaudition" target="_blank" rel="noreferrer"><Twitter size={18} /></a>
              <a href="#" target="_blank" rel="noreferrer"><Linkedin size={18} /></a>
            </div>
          </div>

          {/* Section 2: Middle Links (Mobile: Bottom Full Width) */}
          <div className="footer-middle-links">            
            <div className="links-container-row">
              <span className="quick-links-title">Quick Links:</span>
              <div className="links-wrap">
                <Link to="/roles">Auditions</Link>
                <Link to="/castings">Castings</Link>
                <Link to="/workshops">Workshops</Link>
                <Link to="/ai-studio">AI Studio</Link>
                <Link to="/success-stories">Success Stories</Link>
                <Link to="/about">About Us</Link>
                <Link to="/careers">Careers</Link>
                <Link to="/blog">Blog</Link>
                <Link to="/contact">Contact Us</Link>
                <Link to="/press">Press</Link>
                <Link to="/faq">Help Center</Link>
                <Link to="/trust-safety">Trust & Safety</Link>
                <Link to="/no-scam">No Scam Policy</Link>
                <Link to="/refund-policy">Refund Policy</Link>
                <Link to="/faq">FAQs</Link>
                <Link to="/terms">Terms & Conditions</Link>
                <Link to="/privacy-policy">Privacy Policy</Link>
                <Link to="/cookie-policy">Cookie Policy</Link>
              </div>
            </div>
          </div>

          {/* Section 3: App Badges (Mobile: Right) */}
          <div className="footer-right-apps">
            <a href="#" className="app-link">
              <img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" alt="Google Play" />
            </a>
            <a href="#" className="app-link">
              <img src="https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg" alt="App Store" />
            </a>
          </div>

        </div>

        <div className="footer-copyright-row">
          <p>© {currentYear} BookMyAudition. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default FooterComponent;